export default __webpack_public_path__ + "static/media/local_fire_department-24px.716b81f8.svg";